<template>
    <b-container id="user-reset-password">
        <b-row>
            <b-col class="sign-in-logo">
                <b-img :src="env.COMPANY_APP_URL + '/storage/images/logo.png'"></b-img>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="text-center"><h4>Reset Password</h4></b-col>
        </b-row>
        <b-row>
            <b-col />
            <b-col>
                <b-form @submit.prevent="submitResetNewPassword">
                    <b-form-group
                        id="input-group-password"

                    >
                        <b-form-input
                            id="input-password"
                            v-model="form.password"
                            type="password"
                            required
                            placeholder="Enter new password"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group
                        id="input-group-password-confirm"

                    >
                        <b-form-input
                            id="input-confirm-password"
                            v-model="form.passwordConfirmation"
                            type="password"
                            required
                            placeholder="Confirm new password"
                        ></b-form-input>
                    </b-form-group>
                    <b-button type="submit" variant="success" class="login-button">Reset Password</b-button>
                </b-form>
            </b-col>
            <b-col />
        </b-row>
    </b-container>
</template>

<script>
    import { AbilityBuilder } from '@casl/ability'
    import { mapGetters, mapActions, mapMutations } from 'vuex'

    export default {
        name: 'SignIn',

        data () {
            return {
                form: {
                    password: '',
                    passwordConfirmation: '',
                },
                token: '',
                email: ''
            }
        },

        computed: {
            ...mapGetters({
                authenticated: 'auth/authenticated',
                user: 'auth/user',
                abilities: 'auth/abilities'
            })
        },

        methods: {
            ...mapActions({
                signIn: 'auth/signIn'
            }),

            submitResetNewPassword() {
                const crypto = require('crypto')
                crypto.randomBytes(20, (err, buffer) => {
                    var token = buffer.toString('hex')

                    let url = 'password/reset'
                    axios.post(url, {
                        token: this.token,
                        email: this.email,
                        password: this.form.password,
                        password_confirmation: this.form.passwordConfirmation
                    })
                    .then((res) => {
                        this.showAlertBox('success', 'Password Updated', 'Password updated successfully!')

                        axios.get('/api/user/permissions').then((response) => {
                            this.setAbility(response.data)
                            this.updateAbility(this.abilities)

                            this.token = ''
                            this.email = ''
                            this.form.password = ''
                            this.passwordConfirmation = ''

                            this.$router.push({ name: 'Home'})
                            this.$router.go(this.$router.currentRoute)
                        }).catch((err) => {
                            // console.log(err)
                        })
                    }, (err) => {
                        this.has_error = true
                        let errorResp = err.response.data
                        if (errorResp.errors.password) {
                            if (errorResp.message == 'The given data was invalid.') {
                                let errors = errorResp.errors.password
                                let msg = ''
                                errors.forEach(element => {
                                    // console.log(element)
                                    msg += element + ' '
                                })
                                this.showAlertBox('error', 'Error Resetting Password', msg)
                                this.$router.push({ name: 'SignIn'})
                            }
                        } else {
                            this.showAlertBox('error', 'Error Resetting', 'Password reset issue please use forgot password again.')
                            this.$router.push({ name: 'SignIn'})
                        }
                    })
                })
            },

            ...mapMutations({
                setAbility: 'auth/SET_ABILITIES'

            }),

            updateAbility(abilities) {
                const { can, rules } = new AbilityBuilder();

                let obj = abilities
                obj.forEach(element => {
                    can(element.name, '')
                })

                this.$ability.update(rules);
            },

            openModal(modalName) {
                this.$bvModal.show(modalName)
            },

            closeModal(modalName) {
                this.$bvModal.hide(modalName)
            },
        },

        mounted() {

        },

        created() {
            let uri = window.location.search;
            let params = new URLSearchParams(uri);
            let email = params.get('email');
            let path = this.$route.path
            let token = path.substring(path.lastIndexOf('/') + 1)
            this.token = token
            this.email = email
        }
    }
</script>
<style lang="scss">
    #user-reset-password {
        .sign-in-logo {
            text-align: center;
            margin-left: auto;
            margin-right: auto;
            margin: 0px;
            padding-bottom: 20px;

            img {
                filter: invert(100%);
            }
        }

        .login-button {
            width: 100%;
            text-align: center;
        }
    }
</style>
